import { NebulyAggregateKind } from '../../../api/generated/model/nebulyAggregateKind';

export const BUILT_IN_AGGREGATE_CATEGORY_NAMES = new Set<string>([
  ...Object.values(NebulyAggregateKind),
  'intent',
  'user_intent',
  'action',
  'user_action',
  'category',
  'sub_topic',
  'model_suggestion',
  'model_issue',
  'type_of_problem_v2',
  'negative_intent',
  'negative_intent_v2',
  'negative_user_intent_v2',
  'risky_behavior',
]);

export const filterCustomAggregates = <T extends { category_name: string }>(aggregates: T[]): T[] =>
  aggregates.filter((aggregate) => !BUILT_IN_AGGREGATE_CATEGORY_NAMES.has(aggregate.category_name));

function normalizeAggregateName(value: string): string {
  return value.toLowerCase().replace(/[-_\s]/g, '');
}

/**
 * AIFI / AI Fluency dimension is a system axis used for proficiency scoring.
 * It must never appear in interaction details, even if the BE still sends it.
 */
export function isHiddenInteractionDetailAggregate(aggregate: {
  category_name: string;
  display_name?: string;
  exclude_from_taxonomy?: boolean;
}): boolean {
  if (aggregate.exclude_from_taxonomy) return true;

  return [aggregate.category_name, aggregate.display_name].some((name) => {
    if (!name) return false;
    const normalized = normalizeAggregateName(name);
    return normalized.includes('aifluencydimension') || normalized.includes('aifidimension');
  });
}

export const filterInteractionDetailCustomAggregates = <
  T extends { category_name: string; display_name?: string; exclude_from_taxonomy?: boolean },
>(
  aggregates: T[],
): T[] => aggregates.filter((aggregate) => !isHiddenInteractionDetailAggregate(aggregate));
